export default {
  activateLandingPageTitle: 'Eventos',
  activateProductCardTitle: 'Eventos',
  activateProductPageTitle: 'Reservar eventos',
  allProductsLandingPageTitle: 'Reservar experiências únicas',
  apply: 'Aplicar',
  buyTickets: 'Comprar ingressos',
  cancel: 'Cancelar',
  clear: 'Limpar',
  clearFilters: 'Limpar filtros',
  discoverExperiences: 'Descobrir experiências',
  exclusive: 'Exclusivo',
  experience: 'experiência',
  experiencePhotoOfListing:
    'Foto da experiência {{photoNumber}} do anúncio {{listingTitle}}',
  experiences: 'experiências',
  filterExperiences: 'Filtrar experiências',
  hostedBy: 'Hospedado por',
  hostLandingPageTitle: 'Experiências locais',
  hostProductCardTitle: 'Experiências locais',
  hostProductPageTitle: 'Reservar experiências locais',
  landingPageTitle: 'Reservar experiências únicas',
  mainLandingPageTitle: 'Todas as experiências',
  more: 'Mais',
  noExperiencesFound: 'Nenhuma experiência encontrada',
  noExperiencesFoundFor: 'Nenhuma experiência encontrada para',
  profileImageOfHost: 'Imagem de perfil do anfitrião {{hostName}}',
  reserve: 'Reservar',
  reserveLandingPageTitle: 'Atividades e comodidades',
  reserveProductCardTitle: 'Atividades',
  reserveProductPageTitle: 'Reservar atividades e comodidades',
  resultsPageTitle: 'Reservar experiências e atividades',
};
